var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    width: 26,
    height: 26,
    rx: 6,
    transform: "rotate(90 26 0)",
    fill: "#4F3D97"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8048_136513",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 15.0526,
    height: 15.0526,
    transform: "matrix(-1 -1.19249e-08 -2.38498e-08 1 20.5273 5.4707)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8048_136513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 11.9202L18.0471 16.6654C18.2608 16.8885 18.5329 17 18.8632 17C19.1936 17 19.4656 16.8885 19.6794 16.6654C19.8931 16.4423 20 16.1584 20 15.8137C20 15.4689 19.8931 15.185 19.6794 14.962L14.3161 9.36502C14.083 9.12167 13.8109 9 13.5 9C13.1891 9 12.917 9.12167 12.6839 9.36502L7.32063 14.962C7.10688 15.185 7 15.4689 7 15.8137C7 16.1584 7.10688 16.4423 7.32063 16.6654C7.53438 16.8885 7.80643 17 8.13677 17C8.46712 17 8.73916 16.8885 8.95292 16.6654L13.5 11.9202Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpWhite);
export default __webpack_public_path__ + "static/media/arrow_up_white.340ff0b89e40d2cff6e5859260cb844a.svg";
export { ForwardRef as ReactComponent };